// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.neopin",
    name: "NEOPIN",
    homepage: "https://neopin.io/",
    image_id: "424c54b5-b786-4c14-871f-61d5c5ded800",
    app: {
        browser: null,
        ios: "https://itunes.apple.com/app/id1600381072",
        android: "https://play.google.com/store/apps/details?id=com.blockchain.crypto.wallet.neopin",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "nptwc://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map